namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class DetailAdmIszrAgenda extends GContentBase {
        private dataListDescription: Gordic.General.ApplicationInterface.GDataListDescription;
        private data: Gordic.AdmIsl.Interface.GAdmIszrAgendaReadDto;
        private newRecord: boolean;
        private detailObj: DetailAdmIszrAgendaObj & GContent;
        private duvodUcelAdministrace: boolean;

        // hodnota parametru adx_checkiconad 
        private currentFilter: any;
        private gridRc: Gordic.Components.GridRC<any>;
        private createPreviousAndNextAction: boolean;

        onDetailBuilderInit(builder: Gordic.Gin.DetailBuilder.GDetailBuilder) {
            this.detailObj = $.extend(this, new DetailAdmIszrAgendaObj());
            this.detailObj.createBase({
                contentName: "detailAdmIszrAgenda",
                contentCaption: "jres:33000753",  //RC 33000753 : Agenda ISZR
                newRecord: this.newRecord,
                data: this.data,
                dataListDescription: this.dataListDescription,
                addPlatnost: false,
                currentFilter: this.currentFilter,
                gridRc: this.gridRc,
                createPreviousAndNextAction: this.createPreviousAndNextAction,
            });
            var tabs: Gordic.Gin.DetailBuilder.TabParamsId[] | ObjectLiteral<Gordic.Gin.DetailBuilder.TabParams> | null = [];
            if (this.newRecord == false) {
                tabs.push(this.detailObj.getAgendoveRoleTab());
                if (this.duvodUcelAdministrace == true)
                   tabs.push(this.detailObj.getAgendyUrovnePristupuTab());
                tabs.push(this.detailObj.getAuditPristupuTab());
            }
            var groups: IGTabGroupOptions[] = [];
            if (this.newRecord == false) {
                groups.push(this.detailObj.getAgendoveRoleGroup());
                if (this.duvodUcelAdministrace == true)
                    groups.push(this.detailObj.getAgendyUrovnePristupuGroup());
                groups.push(this.detailObj.getAuditPristupuGroup());
            }
            builder.withComponent<this>("DetailAdmIszrAgenda", {
                statusBar: this.detailObj.createStatusBar(),
                menuBar: this.detailObj.createMenuBar(),
                headerForm: this.detailObj.createFormComplet(),
                commandBar: this.detailObj.createCommandBar(),
                sidePanels: [/*this.detailObj.getAuditPristupu(),*/ this.detailObj.getPoznamky()],
                tabs: tabs,
                tabGroups: groups,
            })
        }

        onContentReady() {
            this.detailObj.finishBuilder()
        }

        closing() {
            return this.detailObj.closeAction();
        }
    }


    export class DetailAdmIszrAgendaObj extends GAdmDetailBase<Gordic.AdmIsl.Interface.GAdmIszrAgendaReadDto> {

        create() {

        }

        textPopis(): string | undefined | null {
            return this.data["nazev"]
        }

        setSxsDetail(): string {
            return "{0}".format((this.data.agenda) ? this.data.agenda.toString() : "");
        }

        saveData(data: Gordic.AdmIsl.Interface.GAdmIszrAgendaSaveDto, close: boolean) {
            (this.cnt.isl.AdmIszrAgenda.upsert({ data: data }).get() as any).done((output) => {
                if (output.result.kind === Utils.GOperationResultKind.Success) {
                    Gordic.Data.readerCache.clearCache("Gordic.ControlsLogic.Client.GReaderSzrsage")
                    this.pendingAction("actSave", true)
                    this.data = output.data;
                    this.metadata = this.data.MetaData;
                    this.updateGridBase().done(() => {
                        this.showSuccessSave(close);
                        if (close == true) {
                            this.closeAction(true).done(() => { this.cnt.close() });
                        } else
                            this.reloadDataBase();
                    })
                } else {
                    this.checkErrors(output.result.errors)
                    this.pendingAction("actSave", false)
                }
            }).fail((err) => {
                this.pendingAction("actSave", false)
            })
        }

        reloadData(filterObj: any, dataObj: any) {
            $.content().navigate(["Gordic.Adm.WebControls.DetailAdmIszrAgenda", filterObj], dataObj);
        }

        updateGrid(filter: any, grid: any): any {
            return this.cnt.isl.AdmIszrAgenda.list({
                filters: filter
            }).getView().promise()
        }

        createTitle(): string {
            if (this.options.newRecord == true)
                return "jres:32000121";
            return "{0} - {1}".format(this.options.contentCaption, (this.data.nazev) ? this.data.nazev : "");
        }

        createMenuBar(): Gordic.Gin.DetailBuilder.GDetailBuilderMenuItemDef {
            return [
                "actEdit*",
                { action: this.cnt.actions.actSave, favorite: true, actionContext: { close: false } },
                "actCancelEdit*",
                { action: this.cnt.actions.actPrevious, favorite: true, align: "opposite" },
                { action: this.cnt.actions.actNext, favorite: true, align: "opposite" }
            ]
        }

        createCommandBar(): Gordic.Gin.DetailBuilder.GDetailBuilderMenuItemDef {
            return [
                { caption: "jres:32000161", action: this.cnt.actions.actSave, customClass: "g-button--primary", favorite: true, actionContext: { close: true } },
                "actClose*"
            ]
        }

        createActions(): { [akceName: string]: GAction | GActionParamsDefObj } | null {
            return null
        }

        setEditMode(editMode: boolean) {

        }

        createForm() {
            this.MakeField("agenda", { flag: this.createFlagNemenne() });
            this.MakeField("nazev");
            this.MakeField("poznamka");
            this.MakeSelectField("ur_pri", Gordic.Prefabs.Select.ginsurp(), { model: "model.ur_pri=value.ur_pri" });
            this.MakeField("seznam_udaju");
            this.MakeBoolField("s_prist_rob");
            this.MakeField("seznam_udaju_ros");
            this.MakeField("seznam_udaju_isc");
            this.MakeField("seznam_udaju_iseo");
            this.MakeField("sezn_udaju_aiseop");
            this.MakeSelectField("aktivita", Gordic.Prefabs.Select.gincakt());
            this.MakeField("dat_zmena");
            this.MakeSelectField("zmenu_prov", Gordic.Prefabs.Select.ginszmp(), { model: "model.zmenu_prov=value.ixs_zmp" });
        }

        getAgendoveRoleTab(): Gordic.Gin.DetailBuilder.TabParamsId {
            return {
                tabParams: {
                    id: "tab-agendove-role",
                    title: "jres:33000756", //RC 33000756 : Agendové role
                    opened: true,
                    locked: true,
                    group: { id: "_tab-agendove-role" }
                },
                contentParams: {
                    className: "Gordic.Adm.WebControls.SeznamAdmIszrRole",
                    serverParams: {
                        Id: "SeznamAdmIszrRole",
                        agenda: this.data.agenda,
                        tabOpen: true
                    }
                }
            }
        }

        getAgendyUrovnePristupuTab(): Gordic.Gin.DetailBuilder.TabParamsId {
            return {
                tabParams: {
                    id: "tab-urovne-pristupu",
                    title: "jres:33000765", //RC 33000765 : Úrovně přístupu
                    opened: true,
                    locked: true,
                    group: { id: "_tab-urovne-pristupu" }
                },
                contentParams: {
                    className: "Gordic.Adm.WebControls.SeznamAdmIszrUrovenPristupu",
                    serverParams: {
                        Id: "SeznamAdmIszrUrovenPristupu",
                        agenda: this.data.agenda,
                        tabOpen: true
                    }
                }
            }
        }

        getAgendoveRoleGroup(): IGTabGroupOptions {
            return { id: "_tab-agendove-role", caption: "jres:33000756" }
        }

        getAgendyUrovnePristupuGroup(): IGTabGroupOptions {
            return { id: "_tab-urovne-pristupu", caption: "jres:33000765" }
        }
    }
}